import { render, staticRenderFns } from "./DialogueEdit.vue?vue&type=template&id=63fd3cd9&scoped=true"
import script from "./DialogueEdit.vue?vue&type=script&lang=js"
export * from "./DialogueEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogueEdit.vue?vue&type=style&index=0&id=63fd3cd9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd3cd9",
  null
  
)

export default component.exports